import { HTTPClientInterface, HTTPRequest } from '@shared/core/HTTPClientInterface';
import { buildURL, SystemURL } from './URLCatalog';

export class NotificationsService {
	private httpClient: HTTPClientInterface;

	constructor(httpClient: HTTPClientInterface) {
		this.httpClient = httpClient;
	}

	async fetchNotifications(orgId: string, pageSize: string, lastKey: string): Promise<any> {
		const request = new HTTPRequest();
		request.url = buildURL(SystemURL.Notifications.getNotifications, {
			org_id: orgId,
			pageSize,
			lastKey,
		});
		request.method = 'GET';
        const response = await this.httpClient.execute(request);
        return response.result;
	}

	async fetchLastReadTimestamp(orgId: string): Promise<any> {
		const request = new HTTPRequest();
		request.url = buildURL(SystemURL.Notifications.getLastReadTimestamp, { org_id: orgId });
		request.method = 'GET';
        const response = await this.httpClient.execute(request);
        return response.result;
	}

	async updateLastReadTimestamp(orgId: string): Promise<any> {
		const request = new HTTPRequest();
		request.url = buildURL(SystemURL.Notifications.postLastReadTimestamp, { org_id: orgId });
		request.method = 'POST';
		return this.httpClient.execute(request);
	}
}
